import Application from "../../../Application";
import { ICredentialsService } from "../../../authentication/service/CredentialsService";

export default class GetSelectedLanguageInteractor {
  private application: Application;
  private credentialsService: ICredentialsService;

  constructor({ application, credentialsService }: any) {
    this.credentialsService = credentialsService;
    this.application = application;
  }

  async execute() {
    return await this.credentialsService.getLanguage();
  }
}
